<template style="height: 100%;">
  <div class="zreport">
    <el-button type="primary" @click="dc" class="dc">导出报告</el-button>
    <h2>{{ data.ceri }}</h2>
    <h3>{{datasetsc }}年全体学生心理健康情况普测报告</h3>
    <div class="div1">
      <p>一、总体概况</p>
      <p>本次心理普查的主要内容是学生的心理问题症状与生活满意度，分别采用症状自评量表（SCL-90）和青少年学生生活满意度量表进行测试评估。截至{{ data.dates }}，贵单位应参测学生{{data.studentCount }}人，实际参测学生{{ data.studentCountSj }}人，其中完成症状自评量表（SCL-90）{{ data.studentCountSCL90}}人次、完成青少年学生生活满意度量表{{
       data.studentCountLSOFT 
      
      }}人次，实际完整参测学生{{ data.studentCountSjCount }}人，完成比{{ data.studentCountSjCountZb }}%。</p>


      <p>本次心理普查，参加测试的男生有{{ data.sex1Count }}人，占参测人数的{{ data.sex1CountZb }}%;参测女生有{{ data.sex2Count }}人，占参测人数的{{
        data.sex2CountZb }}%，如图所示。</p>


      <div class="myChart1" id="myChart" :style="{ width: '300px', height: '300px' }"></div>
      <p>本次心理普查，参测国科大学籍学生{{ data.educationXJ }}人，占参测人数的{{ data.educationXJZb }}%，参测非国科大学籍联培生有{{ data.educationLP
      }}人，占参测人数的{{ data.educationLPZb }}%，如图所示。</p>
      <div class="myChart1" id="myChart1s" :style="{ width: '300px', height: '300px' }"></div>

      <p>本次心理普查，国科大学籍学生中，参测本科生{{ data.bkxj }}人，占参测人数的{{ data.studentCountSj == 0 ? 0: ((Number(data.bkxj)  / Number(data.studentCountSj)) * 100).toFixed(2) }}%，硕士研究生有{{
        data.ssxj }}人，占参测人数的{{ data.studentCountSj==0? 0 : ((Number(data.ssxj) / Number(data.studentCountSj)) * 100).toFixed(2) }}%，参测博士研究生有{{ data.bsxj }}人，占参测人数的{{ data.studentCountSj ==0?0:  ((Number(data.bsxj) / Number(data.studentCountSj)) * 100).toFixed(2) }}%；非国科大学籍联培生中，参测本科生{{ data.bklp }}人，占参测人数的{{ data.studentCountSj == 0?0:  ((Number(data.bklp) / Number(data.studentCountSj)) * 100).toFixed(2) }}%，硕士研究生有{{ data.sslp }}人，占参测人数的{{ data.studentCountSj==0?0: ((Number(data.sslp) / Number(data.studentCountSj)) * 100).toFixed(2) }}%，参测博士研究生有{{ data.bslp }}人，占参测人数的{{ data.studentCountSj==0?0:((Number(data.bslp) / Number(data.studentCountSj)) * 100).toFixed(2)
  }}%。如图所示。</p>
      <div class="myChart1" id="myChart4" :style="{ width: '600px', height: '400px' }"></div>
    </div>
    <div class="div2">
      <p>二、量表情况统计</p>
      <p>（一）总体情况统计</p>
      <p>贵单位参测学生中疑似出现心理问题的学生有{{ data.phProblemCountBX + data.phProblemCountLP }}人，占{{ Number(data.phProblemCountBXZb) +
        Number(data.phProblemCountLPZb) }}%，总体满意度为基本不满意的学生有{{ data.bmyCountBX + data.bmyCountLP
  }}人，占{{ (Number(data.bmyCountBXZb) + Number(data.bmyCountLPZb)) }}%。</p>
    </div>
    <tbody class="tbody1" style="margin-left: 25%;padding-top: 20px;">
      <thead>
        <tr>
          <td rowspan="2">类别</td>
          <td colspan="2">本校生</td>
          <td colspan="2">联培生</td>
        </tr>
        <tr>
          <td>人数</td>
          <td>百分比</td>
          <td>人数</td>
          <td>百分比</td>
        </tr>
      </thead>
      <tr>
        <td>疑似出现心理问题的学生</td>
        <td>{{ data.phProblemCountBX }}</td>
        <td>{{ data.phProblemCountBXZb }}%</td>
        <td>{{ data.phProblemCountLP }}</td>
        <td>{{ data.phProblemCountLPZb }}%</td>
      </tr>
      <tr>
        <td>满意度为基本不满意的学生</td>
        <td>{{ data.bmyCountBX }}</td>
        <td>{{ data.bmyCountBXZb }}%</td>
        <td>{{ data.bmyCountLP }}</td>
        <td>{{ data.bmyCountLPZb }}%</td>
      </tr>
    </tbody>
    <div class="div3">（二）疑似出现心理问题的情况统计</div>
    <tbody class="tbody1" style="margin-left: 23%;">
      <thead>
        <tr>
          <td>分类</td>
          <td>总人数</td>
          <td>男生</td>
          <td>女生</td>
          <td>本校生</td>
          <td>联培生</td>
        </tr>
      </thead>

      <tr v-for="(item,index) in data.phyProblemList" :key="index">
        <td>{{ item.factorName }}</td>
        <td>{{ item.total }}</td>
        <td>{{ item.manCount }}</td>
        <td>{{ item.womanCount }}</td>
        <td>{{ item.bxCount }}</td>
        <td>{{ item.lpCount }}</td>
      </tr>

    </tbody>
    <p></p>
    <tbody class="tbody1">
      <thead>
        <tr>
          <td>分类</td>
          <td>总人数</td>
          <td>大一</td>
          <td>大二</td>
          <td>大三</td>
          <td>大四及以上</td>
          <td>硕一</td>
          <td>硕二</td>
          <td>硕三及以上</td>
          <td>博一</td>
          <td>博二</td>
          <td>博三及以上</td>
        </tr>
      </thead>
      <tr v-for="(item,index) in data.phyProblemList" :key="index">
        <td>{{ item.factorName }}</td>
        <td>{{ item.total }}</td>
        <td>{{ item.degree1Count }}</td>
        <td>{{ item.degree2Count }}</td>
        <td>{{ item.degree3Count }}</td>
        <td>{{ item.degree4Count }}</td>
        <td>{{ item.degree5Count }}</td>
        <td>{{ item.degree6Count }}</td>
        <td>{{ item.degree7Count }}</td>
        <td>{{ item.degree8Count }}</td>
        <td>{{ item.degree9Count }}</td>
        <td>{{ item.degree10Count }}</td>
        <!-- <td>{{ data.degree11Count }}</td> -->
      </tr>

    </tbody>

    <div class="div3">
      <p>（三）生活满意度为基本不满意的情况统计</p>
      <tbody class="tbody1">

        <thead>
          <tr>
            <th>分类</th>
            <th>总人数</th>
            <th>男生</th>
            <th>女生</th>
            <th>本校生</th>
            <th>联培生</th>
          </tr>
        </thead>

        <tr v-for="(item,index) in data.jbbmyList" :key="index">

          <td>{{ item.factorName }}</td>
          <td>{{ item.total }}</td>
          <td>{{ item.manCount }}</td>
          <td>{{ item.womanCount }}</td>
          <td>{{ item.bxCount }}</td>
          <td>{{ item.lpCount }}</td>
        </tr>


      </tbody>


      <tbody class="tbody1">
        <thead>
          <tr>
            <td>分类</td>
            <td>总人数</td>
            <td>大一</td>
            <td>大二</td>
            <td>大三</td>
            <td>大四及以上</td>
            <td>硕一</td>
            <td>硕二</td>
            <td>硕三及以上</td>
            <td>博一</td>
            <td>博二</td>
            <td>博三及以上</td>
          </tr>
        </thead>
        <tr v-for="(item,index) in data.jbbmyList" :key="index">
          <td>{{ item.factorName }}</td>
          <td>{{ item.total }}</td>
          <td>{{ item.degree1Count }}</td>
          <td>{{ item.degree2Count }}</td>
          <td>{{ item.degree3Count }}</td>
          <td>{{ item.degree4Count }}</td>
          <td>{{ item.degree5Count }}</td>
          <td>{{ item.degree6Count }}</td>
          <td>{{ item.degree7Count }}</td>
          <td>{{ item.degree8Count }}</td>
          <td>{{ item.degree9Count }}</td>
          <td>{{ item.degree10Count }}</td>
        </tr>

      </tbody>


      <!-- <p>（三）心理健康水平低情况</p>

      <p>贵单位心理健康水平低的{{ data.MentalCount }}人中，性别分布上，男生{{data.UPIQ25Sex1}}人，女生{{data.UPIQ25Sex0}}人；学历层次分布上，硕士研究生{{data.UPIQ25Degree0}}人，博士研究生{{data.UPIQ25Degree1}}人。各专业心理健康水平低人员情况见下表。</p>

      <tbody class="tbody1">
        <thead>
          <tr>
            <th>类目</th>
            <th colspan="2">学历层次</th>
            <th colspan="2">性别</th>
          </tr>
        </thead>

        <tr>
          <td></td>
          <td>硕士研究生</td>
          <td>博士研究生</td>
          <td>男</td>
          <td>女</td>
        </tr>
        <tr v-for="item in data.UPILists" :key="item">
          <td >{{item.Specialty}}</td>
          <td>{{item.Degree1}}</td>
          <td>{{item.Degree2}}</td>
          <td>{{item.Sex1}}</td>
          <td>{{item.Sex0}}</td>
        </tr>
      </tbody> -->



      <!-- <p>（四）中度以上抑郁情况</p>

      <p>贵单位中度以上抑郁的{{data.Depressed}}人中，性别分布上，男生{{data.SDSSex1}}人，女生{{data.SDSSex0}}人；学历层次分布上，硕士研究生{{data.SDSDegree0}}人，博士研究生{{data.SDSDegree1}}人。各专业中度以上抑郁人员情况见下表
      </p>

      <tbody class="tbody1">
        <thead>
          <tr>
            <th>类目</th>
            <th colspan="2">学历层次</th>
            <th colspan="2">性别</th>
          </tr>
        </thead>

        <tr>
          <td></td>
          <td>硕士研究生</td>
          <td>博士研究生</td>
          <td>男</td>
          <td>女</td>
        </tr>
        <tr v-for="item in data.SDSLists" :key="item">
          <td >{{item.Specialty}}</td>
          <td>{{item.Degree1}}</td>
          <td>{{item.Degree2}}</td>
          <td>{{item.Sex1}}</td>
          <td>{{item.Sex0}}</td>
        </tr>
      </tbody> -->



      <!-- <p>（五）曾经有过自杀意念情况</p>
      <p>贵单位曾经有过自杀意念的{{ data.Suicide }}人中，性别分布上，男生{{data.QSASex1}}人，女生{{ data.QSASex0 }}人；学历层次分布上，硕士研究生{{data.QSADegree0}}人，博士研究生{{ data.QSADegree1 }}人。各专业曾经有过自杀意念人员情况见下表。
      </p>
      <tbody class="tbody1">

        <thead>
          <tr>
            <th>类目</th>
            <th colspan="2">学历层次</th>
            <th colspan="2">性别</th>
          </tr>
        </thead>

        <tr>
          <td></td>
          <td>硕士研究生</td>
          <td>博士研究生</td>
          <td>男</td>
          <td>女</td>
        </tr>

        <tr  v-for="item in data.QSALists" :key="item">
          <td>{{item.Specialty}}</td>
          <td>{{item.Degree1}}</td>
          <td>{{item.Degree2}}</td>
          <td>{{item.Sex1}}</td>
          <td>{{item.Sex0}}</td>
        </tr>

      </tbody> -->

      <p>三、综合排查结果</p>
      <p>本次心理普查综合排查划分四个等级，各等级划分标准及处理建议和措施见下表：</p>
      <p>注：心理测量只作为评估辅助工具，且为当事人主观填写，测量结果仅供参考，请结合实际情况进行综合评估与使用。</p>
      <tbody>
        
        <thead>
          <tr>
            <td style="width: 120px;">风险等级</td>
            <td>风险标准</td>
            <td style="width: 120px;">处理等级</td>
            <td style="width: 800px;">建议措施</td>
          </tr>
        </thead>
        <tr>
          <td style="width: 120px;">重度</td>
          <td>SCL-90总分超过160分或阳性项目数超过43项，且抑郁或焦虑因子得分>2，且生活满意度量表T &lt; 25.40 </td>
          <td style="width: 120px;">密切陪护</td>
          <td style="width: 800px; text-align: left; padding: 10px;">
            心理辅导员或心理咨询师须及时与当事人谈心谈话，引导当事人就医或接受专业人员帮助，初步评估并向心理中心报告。如情况属实（症状显著，确有自杀计划或自杀未遂，仅有自杀意念可以列为中等），须及时密切陪护（至少两名同性别人员24小时陪护），联系监护人及时到场，及时转介就医。
          </td>
        </tr>
        <tr>
          <td style="width: 120px;">中度</td>
          <td>SCL-90总分超过160分或阳性项目数超过43项，且抑郁或焦虑因子得分>2，且生活满意度量表T&lt; 32.80</td>
          <td style="width: 120px;">重点关注</td>
          <td style="width: 800px; text-align: left; padding: 10px;">
            心理辅导员应及时与当事人谈心谈话，引导当事人接受专业人员帮助，初步评估（是否有自杀计划，是否有精神障碍诊断）并向心理中心报告。如情况属实（排除自杀计划和严重精神障碍诊断，有长期内心冲突或人际关系不良），建议当事人预约心理咨询或就医诊断治疗，须重点关注（每周谈心谈话一次），及时与监护人联系了解情况并告知现状。
          </td>
        </tr>
        <tr>
          <td style="width: 120px;">轻度</td>
          <td>SCL-90总分超过160分或阳性项目数超过43项，或任一因子分超过2分，或生活满意度量表T&lt; 32.80</td>
          <td style="width: 120px;">适当关注</td>
          <td style="width: 800px; text-align: left; padding: 10px;">
            心理辅导员应适时与当事人谈心谈话，给予心理辅导，予以适当关注（每两周谈心谈话一次），找到监护人的联系方式，以便必要时可以及时沟通情况。</td>
        </tr>
        <tr>
          <td style="width: 120px;">良好</td>
          <td>不满足以上任一条件</td>
          <td style="width: 120px;">无</td>
          <td style="width: 800px; text-align: left; padding: 10px;">无特别建议，保持正常的交流沟通即可。</td>
        </tr>
      </tbody>
      <p>贵单位本次心理普查综合排查中，划分为重度风险{{ data.severe }}人，占比{{ data.severeZB }}%；划分为中度风险{{ data.moderate }}人，占比 {{ data.moderateZB
      }}%；划分为轻度风险{{ data.mild }}人，占比{{ data.mildZB }}%；划分为良好{{ data.good }}人，占比{{ data.goodZB }}%。综合排查风险等级情况见下图。</p>
    </div>
    <div class="myChart3" id="myChart3" style="width: 400px;height: 400px;margin-left: 38%;"></div>
    <p>在本次综合排查中，重度风险中男生{{ data.severeSex1 }}人，女生{{ data.severeSex0 }}人；中度风险中男生{{ data.moderateSex1 }}人，女生{{
      data.moderateSex0
    }}人；轻度风险中男生{{ data.mildSex1 }}人，女生{{ data.mildSex0 }}人，分布如下图所示。</p>


    <div class="severeSex1" id="severeSex1" style="width:600px;height:400px;margin-left: 30%;padding-top:30px"></div>


    <p style="line-height: 30px;font-size: 16px;">在本次综合排查中，本校生：重度风险中本科生{{ data.severeDegree0 }}人，硕士研究生{{
      data.severeDegree1 }}人，博士研究生{{ data.severeDegree2 }}人；中度风险中本科生{{ data.moderateDegree0 }}人，硕士研究生{{
    data.moderateDegree1 }}人，博士研究生{{ data.moderateDegree2 }}人；轻度风险中本科生{{ data.mildDegree0 }}人，硕士研究生{{ data.mildDegree1
  }}人，博士研究生{{ data.mildDegree2 }}人。联培生：重度风险中本科生{{ data.severeDegreeLP0 }}人，硕士研究生{{ data.severeDegreeLP1 }}人，博士研究生{{
  data.severeDegreeLP2 }}人；中度风险中本科生{{ data.moderateDegreeLP0 }}人，硕士研究生{{ data.moderateDegreeLP1 }}人，博士研究生{{
    data.moderateDegreeLP2 }}人；轻度风险中本科生{{ data.mildDegreeLP0 }}人，硕士研究生{{ data.mildDegreeLP1 }}人，博士研究生{{
    data.mildDegreeLP2 }}人。分布如下图所示。</p>

    
    <div class="myChart1" id="myChart5" :style="{ width: '600px', height: '400px' }"></div>
    <div class="myChart1" id="myChart5s" :style="{ width: '600px', height: '400px' }"></div>
    <div class="div4">
      <h5>综合排查名单</h5>
      <p>1、重度风险人员：风险人数：{{ data.severe }}人，预警比例：{{ ((Number(data.severe) / Number(data.studentCountSjCount))*100).toFixed(2)  }}%。</p>
      <tbody>
        <thead>
          <tr>
            <td style="width:120px;">序号</td>
            <td style="width:220px;">学号</td>
            <td style="width:180px;">性别</td>
            <td style="width:280px;">专业</td>
            <td style="width:180px;">学历</td>
            <td style="width:180px;">SCL-90总分</td>
            <td style="width:180px;">生活满意度总分均分</td>
          </tr>
        </thead>
        <tr v-for="(item, i) in data.severeTableList" :key="i">
          <td>{{ i + 1 }}</td>
          <td>{{ item.userID }}</td>
          <td>{{ item.sex }}</td>
          <td>{{ item.specialty }}</td>
          <td>{{ item.degree }}</td>
          <td>{{ item.sclScore }}</td>
          <td>{{ item.lsoftScore }}</td>
        </tr>
      </tbody>

      <p>2、中度风险人员：风险人数：{{ data.moderate }}人，预警比例：{{ ((Number(data.moderate) / Number(data.studentCountSjCount))*100).toFixed(2) }}%。</p>
      <tbody>
        <thead>
          <tr>
            <td style="width:120px;">序号</td>
            <td style="width:220px;">学号</td>
            <td style="width:180px;">性别</td>
            <td style="width:280px;">专业</td>
            <td style="width:180px;">学历</td>
            <td style="width:180px;">SCL-90总分</td>
            <td style="width:180px;">生活满意度总分均分</td>
          </tr>
        </thead>
        <tr v-for="(item, i) in data.moderateTableList" :key="i">
          <td>{{ i + 1 }}</td>
          <td>{{ item.userID }}</td>
          <td>{{ item.sex }}</td>
          <td>{{ item.specialty }}</td>
          <td>{{ item.degree }}</td>
          <td>{{ item.sclScore }}</td>
          <td>{{ item.lsoftScore }}</td>
        </tr>
      </tbody>

      <p>3、轻度风险人员：风险人数：{{ data.mild }}人，预警比例 {{ ((Number(data.mild) / Number(data.studentCountSjCount))*100).toFixed(2) }}%。</p>
      <tbody>
        <thead>
          <tr>
            <td style="width:120px;">序号</td>
            <td style="width:220px;">学号</td>
            <td style="width:180px;">性别</td>
            <td style="width:280px;">专业</td>
            <td style="width:180px;">学历</td>
            <td style="width:180px;">SCL-90总分</td>
            <td style="width:180px;">生活满意度总分均分</td>
          </tr>
        </thead>
        <tr v-for="(item, i) in data.mildTableList" :key="i">
          <td>{{ i + 1 }}</td>
          <td>{{ item.userID }}</td>
          <td>{{ item.sex }}</td>
          <td>{{ item.specialty }}</td>
          <td>{{ item.degree }}</td>
          <td>{{ item.sclScore }}</td>
          <td>{{ item.lsoftScore }}</td>
        </tr>
      </tbody>
    </div>

    <div class="dis" v-if="dis">
      <div class="dis-s" style="text-align: center;">
        <img style="width: 200px;height: 200px;" src="../../../assets/4092865.gif" alt="">
        <p style="font-size: 18px;">数据加载中，请稍等...</p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      datasetsc:'',
      PaperResultID: '',
      ReportType: '',
      data: '',
      DeptID: '',
      NianJI: '',
      urldizhi: '',
      dis: true
    }
  },
  methods: {
    t1() {
      let myChart = this.$echarts.init(document.getElementById('myChart'));
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: function (data) {
            return ("性别：" + data['name'] + "</br>人数: " + data['data'].shum + "</br>占比：" + data['data'].value + "%")
          }
        },
        color: ['#fac090', '#4473b9'],
        series: [
          {
            type: 'pie',
            radius: '50%',
            //data: this.data.RosesSex,
            data: [
              { value: this.data.rosesSex[0].value, name: "女生", shum: this.data.Sex2Count },
              { value: this.data.rosesSex[1].value, name: "男生", shum: this.data.Sex1Count }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ],
      })
    },

    t1s() {
      let myChart = this.$echarts.init(document.getElementById('myChart'));
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: function (data) {
            return ("性别：" + data['name'] + "</br>人数: " + data['data'].shum + "</br>占比：" + data['data'].value + "%")
          }
        },
        color: ['#fac090', '#4473b9'],
        series: [
          {
            type: 'pie',
            radius: '50%',
            //data: this.data.RosesSex,
            data: [
              { value: this.data.sex2CountZb, name: "女生", shum: this.data.sex2Count },
              { value: this.data.sex1CountZb, name: "男生", shum: this.data.sex1Count }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ],
      })
    },

    t2() {
      let myChart2 = this.$echarts.init(document.getElementById('myChart1s'));
      myChart2.setOption({
        tooltip: {
          trigger: 'item',
          formatter: function (data) { return ("性别：" + data['name'] + "</br>人数: " + data['data'].shum + "</br>占比：" + data['data'].value + "%") }
        },
        color: ['#4473b9', '#ed7d31'],
        series: [{
          type: 'pie',
          radius: '50%',
          data: [
            { value: this.data.educationXJZb, name: "国科大学籍学生", shum: this.data.educationXJ },
            { value: this.data.educationLPZb, name: "非国科大学籍联培生", shum: this.data.educationLP }
          ],
          emphasis: {
            itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0, 0, 0, 0.5)' }
          }
        }
        ],
      })
    },

    severeSex1() {

      let myChart = this.$echarts.init(document.getElementById('severeSex1'));
      var option = {
        legend: {},
        tooltip: {},
        color: ['#fac090', '#4473b9'],
        dataset: {
          source: [
            ['product', '男生', '女生'],
            ['重度', this.data.severeSex1, this.data.severeSex0],
            ['中度', this.data.moderateSex1, this.data.moderateSex0],
            ['轻度', this.data.mildSex1, this.data.mildSex0],
          ]
        },
        xAxis: { type: 'category' },
        yAxis: {},
        series: [{ type: 'bar' }, { type: 'bar' }]
      };
      myChart.setOption(option);
    },
    t3() {
      let myChart3 = this.$echarts.init(document.getElementById('myChart3'));
      myChart3.setOption({
        tooltip: {
          trigger: 'item',
          formatter: function (data) { return ("预警等级：" + data['name'] + "</br>人数: " + data['data'].shum + "</br>占比：" + data['data'].value + "%") }
        },
        color: ['#C00000', '#ED7D31', '#cece48', '#0170C0',],
        series: [{
          type: 'pie',
          radius: '50%',
          data: [
            { value: this.data.severeZB, name: "重度风险", shum: this.data.severe },
            { value: this.data.moderateZB, name: "中度风险", shum: this.data.moderate },
            { value: this.data.mildZB, name: "轻度风险", shum: this.data.mild },
            { value: this.data.goodZB, name: "良好", shum: this.data.good },
          ],
          emphasis: {
            itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0, 0, 0, 0.5)' }
          }
        }
        ],
      })
    },
    t4() {
      let myChart4 = this.$echarts.init(document.getElementById('myChart4'));
      var option = {
        legend: {},
        tooltip: {},
        color: ['#fac090', '#4473b9'],
        dataset: {
          source: [
            ['product', '本校生', '联培生'],
            ['本科生', this.data.bkxj, this.data.bklp],
            ['硕士生', this.data.ssxj, this.data.sslp],
            ['博士生', this.data.bsxj, this.data.bslp],

          ]
        },
        xAxis: { type: 'category' },
        yAxis: {},
        series: [{ type: 'bar' }, { type: 'bar' }]
      };
      myChart4.setOption(option);
    },


    t5() {
      let myChart5 = this.$echarts.init(document.getElementById('myChart5'));

      var option = {
        legend: {},
        title: [
          {
            text: '本校生'
          }
        ],
        tooltip: {},
        color: ['#4472C4', '#ED7D31', '#939393'],
        dataset: {
          source: [
            ['product', '本科生', '硕士生', '博士生'],
            // ['重度', 1, 2, 3],
            // ['中度', 4, 5, 6],
            // ['轻度', 7, 8, 9],
            ['重度', this.data.severeDegree0, this.data.severeDegree1, this.data.severeDegree2],
            ['中度', this.data.moderateDegree0, this.data.moderateDegree1, this.data.moderateDegree2],
            ['轻度', this.data.mildDegree0, this.data.mildDegree1, this.data.mildDegree2],

          ]
        },
        xAxis: { type: 'category' },
        yAxis: {},
        series: [{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }]
      };
      myChart5.setOption(option);
    },

    t5s() {
      let myChart5 = this.$echarts.init(document.getElementById('myChart5s'));

      var option = {
        legend: {},
        title: [
          {
            text: '联培生'
          }
        ],
        tooltip: {},
        color: ['#4472C4', '#ED7D31', '#939393'],
        dataset: {
          source: [
            ['product', '本科生', '硕士生', '博士生'],
            // ['重度', 1, 2, 3],
            // ['中度', 4, 5, 6],
            // ['轻度', 7, 8, 9],
            ['重度', this.data.severeDegreeLP0, this.data.severeDegreeLP1, this.data.severeDegreeLP2],
            ['中度', this.data.moderateDegreeLP0, this.data.moderateDegreeLP1, this.data.moderateDegreeLP2],
            ['轻度', this.data.mildDegreeLP0, this.data.mildDegreeLP1, this.data.mildDegreeLP2],
          ]
        },
        xAxis: { type: 'category' },
        yAxis: {},
        series: [{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }]
      };
      myChart5.setOption(option);
    },

    dc() {
      this.$Http_Post('ScaleIssue/GetMentalHealthWord', { ReportType: this.ReportType[0], PublishID: this.PaperResultID[0], DeptID : this.DeptID[0] }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.open(res.Data, '_blank');
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
  },
  mounted() {
    this.PaperResultID = [this.$route.query.PaperResultID];
    this.ReportType = [this.$route.query.ReportType];
    this.DeptID = [this.$route.query.DeptID];
    this.NianJI = [this.$route.query.NianJI];
    let _this = this;
    this.$Http_Post('ScaleIssue/GetMentalHealth', { ReportType: this.ReportType[0], PublishID: this.PaperResultID[0], DeptID: [this.$route.query.DeptID][0], NianJI: [this.$route.query.NianJI][0] }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        _this.data = res.Data;
        this.datasetsc= res.Data.dates.substring(0, 4)
        _this.urldizhi = res.Data.urldizhi;
        _this.dis = false;
        this.$nextTick(()=>{
          _this.t1();
          _this.t1s();
          _this.t2();
          _this.t3();
          _this.t4();
          _this.t5();
          _this.t5s();
          _this.severeSex1();
        });
      } else {
        this.Global.request_failure(res.Message);
      }
    })
  },
  
}
</script>
<style>
.zreport {
  width: 1200px;
  margin: 0 auto;
}

.zreport h1,
h2,
h3,
h4,
h5,
h6,
h7 {
  text-align: center;
  margin-top: 20px;
}

.zreport h3 {
  font-size: 20px;
}

.zreport .div1 p {
  font-size: 16px;
  line-height: 30px;
  margin-top: 10px;
}

.zreport .div1 p:nth-child(2) {
  text-indent: 2em;
}

.zreport .div1 p:nth-child(3) {
  text-indent: 2em;
}

.zreport .myChart1 {
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.zreport .div2 p {
  font-size: 16px;
  line-height: 30px;
  margin-top: 10px;
}

.zreport .div2 p:nth-child(2) {
  text-indent: 2em;
}

.zreport tbody {
  width: 500px;
  margin-top: 20px;
  display: inline-block;
  margin-top: 40px;
}

.zreport tbody tr {
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.zreport tbody td {
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.zreport .tbody1 tr {
  height: 50px;
  line-height: 50px;
  text-align: center;
  min-width: 200px;
}

.zreport .tbody1 td {
  height: 50px;
  line-height: 50px;
  text-align: center;
  min-width: 100px;
}

.zreport .div3 {
  margin-top: 40px;
}

.zreport .div3 p {
  font-size: 16px;
  line-height: 30px;
  margin-top: 10px;
}

.zreport thead {
  background-color: bisque;
}

.zreport .div3 tbody {
  margin-left: 50px;
  width: 1100px;
}

.zreport .div3 tbody tr {
  height: 50px;
  line-height: 34px;
  text-align: center;
  width: 200px;
}

.zreport .div3 tbody td {
  height: 50px;
  line-height: 34px;
  text-align: center;
  width: 200px;
}

.zreport .div4 tbody {
  margin-left: 50px;
  width: 1100px;
}

.zreport .div4 p {
  margin-top: 40px;
}

.zp {
  padding-bottom: 60px;
  color: red;
}

.zreport .div4 h5 {
  font-size: 20px;
}

.dc {
  position: fixed;
  top: 20px;
  right: 10px;
}

#myChart4 {
  margin-top: 20px;
}

#myChart5 {
  margin-top: 20px;
}

#myChart5s {
  margin-top: 20px;
}

.zreport thead th {
  background-color: bisque !important;
  color: #3a3a3a;
}

.zreport .dis {
  background-color: #fff;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
}

.zreport .dis .dis-s {
  width: 500px;
  height: 500px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
</style>
